<ziro-collapsible-section-card
  class="animate__animated animate__fadeIn animate__faster"
  data-automation="transfer-public-component"
  [isSwitchHidden]="true"
  [isCollapsible]="false"
>
  <div class="card-header">
    <legend class="bottom-buffer mt-0 pb-2 d-flex">
      <ziro-stacked-icon
        class="icon-sm"
        [stackedIcon]="ZiroStackedIcons[ziroIcons.REASSIGN_USER]"
        parentClass="fa-stack"
      ></ziro-stacked-icon>

      <div class="d-flex flex-column" data-automation="reassign-header">
        {{
          reassignType() === ReassignTypes.PUBLIC_TO_USER
            ? ('tkey;transfer.publicToUser.title' | translate)
            : ('tkey;operations.menu.reassign.text' | translate)
        }}
      </div>
    </legend>

    <div>
      <p data-automation="user-search-title">
        {{
          reassignType() === ReassignTypes.PUBLIC_TO_USER
            ? ('tkey;transfer.publicToUser.userSearch.title' | translate)
            : ('tkey;transfer.userToUser.userSearch.title' | translate)
        }}
      </p>
      @if (!isLoading) {
        <div class="input-group d-flex" (keyup.enter)="onEnterSearchPressed()">
          <ziro-text [borderRadOnlyLeft]="true" [fieldId]="'searchTerm'" class="flex-grow-1"></ziro-text>
          <span class="input-group-append">
            <ziro-button
              #searchButton
              [dataAutomation]="'reassign-search-button'"
              [buttonStyle]="buttonStyles.OUTLINE_PRIMARY"
              [isPending]="isSubmitting"
              [iconPending]="ziroIcons.SAVING"
              [icon]="ziroIcons.SEARCH"
              [isDisabled]="formData.searchTerm?.length < 2"
              [ngbTooltip]="
                formData.searchTerm?.length < 2 ? ('tkey;operations.menu.reassign.search_disabled' | translate) : ''
              "
              [isTooltipDisabled]="formData.searchTerm?.length > 1"
              [borderClass]="'input-btn-end'"
              (clicked)="onSearchClicked()"
            ></ziro-button>
          </span>
        </div>
      }
    </div>
    @if (columns) {
      <fieldset>
        <ziro-datatable
          class="reassign-user-search-datatable"
          [columns]="columns"
          [rowDataSource]="tableRows"
          [uniqueRowIdentifier]="'userId'"
          [dataAutomation]="'reassign-user-search-datatable'"
          [noResultsAlert]="'tkey;operations.menu.reassign.search.no_results' | translate"
          [hasFilter]="false"
        ></ziro-datatable>
      </fieldset>
    }
    <div class="text-end pb-2 border-top pt-3">
      <ziro-button
        [dataAutomation]="'reassign-cancel-button'"
        [buttonStyle]="buttonStyles.OUTLINE_DEFAULT"
        [label]="'tkey;dialogs.button.cancel'"
        [cssClass]="'me-1'"
        [isDisabled]="isSubmitting"
        (clicked)="onCancelClicked()"
      ></ziro-button>
    </div>
  </div>
</ziro-collapsible-section-card>
